<template>
  <el-table :data="releases">
    <el-table-column
      prop="title"
      label="版本名"
      :formatter="emptyTextFormatter"
    >
    </el-table-column>
    <el-table-column
      v-if="showCreatedAt"
      prop="created_at"
      label="创建时间"
      :formatter="timeFormatter"
    >
    </el-table-column>
    <el-table-column
      v-if="showUpdatedAt"
      prop="updated_at"
      label="最后更新"
      width="180"
      :formatter="timeFormatter"
    >
    </el-table-column>
    <el-table-column
      v-if="showPublishedAt"
      prop="published_at"
      label="发布时间"
      :formatter="timeFormatter"
    >
    </el-table-column>
    <el-table-column prop="tags" align="center" label="标签">
      <template slot-scope="scope">
        <TableTags :tags="scope.row.tags"></TableTags>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="90">
      <template slot-scope="scope">
        <div class="table-actions">
          <i
            class="el-icon-view preview-icon-button"
            @click="
              $router.push({
                name: 'release_preview',
                params: { release_id: scope.row.id }
              })
            "
          ></i>
          <i
            class="el-icon-edit-outline icon-button edit-icon-button"
            @click="handleEdit(scope.$index, scope.row)"
            v-show="isSameOwnerOrSuper(scope.row.author.id)"
          ></i>
          <DeleteIconButton
            @delete="handleDelete(scope.row)"
            v-show="isSameOwnerOrSuper(scope.row.author.id)"
          ></DeleteIconButton>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import TableTags from "@/components/TableTags";
import DeleteIconButton from "@/components/DeleteIconButton";
import { ElTableFormatterMixin, ResourceOwnerMixin } from "@/mixins";
export default {
  name: "ReposListAdminTable",
  props: {
    releases: {
      type: Array,
      default: () => []
    },
    showCreatedAt: {
      type: Boolean
    },
    showUpdatedAt: {
      type: Boolean
    },
    showPublishedAt: {
      type: Boolean
    }
  },
  mixins: [ElTableFormatterMixin, ResourceOwnerMixin],
  components: {
    TableTags,
    DeleteIconButton
  },
  methods: {
    handleEdit(idx, release) {
      this.$router.push({
        name: "admin_release_edit",
        params: { release_id: release.id }
      });
    },
    handleDelete(release) {
      this.$emit("delete", release);
    }
  }
};
</script>
